import React from 'react';
import Table from '../../components/Table';
import 'dayjs/locale/pt';
import { useAnalysis } from 'hooks/useAnalysis';

export default function Analyse() {
  const {
    analysis,
    columns,
    columnsForExport,
    exportData,
    openProgress,
    errors,
    errorsWhenPosting,
    handleCloseSnackbar,
    handleImportDataPost,
  } = useAnalysis();

  return (
    <Table
      onPost={handleImportDataPost}
      title="Análise de Saúde"
      route="/analisys/"
      routeAdd="/analyse/"
      columns={columns}
      columnsForExport={columnsForExport}
      errorsPost={errorsWhenPosting}
      hasError={errors.length > 0}
      importButtonVisible
      data={analysis}
      dataLoaded={openProgress}
      exportData={exportData}
      onCloseSnackbar={handleCloseSnackbar}
    />
  );
}
